import {
  CancelPageMutation,
  CancelPageMutationVariables,
  PageType,
} from '../../../types/graphql';
import { ERROR_MESSAGES, REQUEST } from '../../consts';
import client, { hasUnauthenticatedError } from '../../apolloClient';
import { getTeamGuid } from '../../selectors/apiSelectors';

import { Action } from 'redux';
import { Auth } from '@justgiving/auth';
import CancelMutation from '../../queries/cancelPageMutation.gql';
import { IAppState } from '../../types/state.d';
import { ThunkDispatch } from 'redux-thunk';
import config from '../../config';
import { httpActions } from '..';
import { redirectByResponseStatus } from '../../utils';

const deleteTeam = () => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.DELETE_TEAM;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state) as string;

    const { errors } = await client.mutate<
      CancelPageMutation,
      CancelPageMutationVariables
    >({
      mutation: CancelMutation,
      variables: {
        input: {
          id: teamGuid,
          type: PageType.Team,
        },
      },
    });

    if (errors && hasUnauthenticatedError(errors)) {
      redirectByResponseStatus(401);
    }

    if (errors) {
      throw new Error(ERROR_MESSAGES.DELETE_TEAM);
    }

    dispatch(httpActions.httpRequestSuccess(resourceName));
    window.location.assign(config.profileUri);
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error as Error));
  }
};

export default deleteTeam;
